import React, { useEffect, useState } from 'react';
import * as yup from 'yup';
import { Text } from '@chakra-ui/react';
import { Link, useHistory } from 'react-router-dom';
import { ViewIcon, ViewOffIcon } from '@chakra-ui/icons';

import AuthForm from './AuthForm';
import AuthWrapper from './AuthWrapper';

import { resetPassword } from '../../api/auth';
import { PASSWORD_REGEX } from '../../constants/regex';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { LOG_IN_URL } from '../../constants/routerUrl';
import { useDispatch } from 'react-redux';
import { notify } from '../../store/actions/globalActions';

const ResetPassword = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const location = useLocation();
  const [showPass, setShowPass] = useState(false);
  const [showRePass, setShowRePass] = useState(false);

  useEffect(() => {
    if (!location.state) {
      history.replace(LOG_IN_URL);
    } else {
      const { username, phoneNo, otp, minPassLength } = location.state;
      if (!username || !phoneNo || !otp || !minPassLength) {
        history.replace(LOG_IN_URL);
      }
    }
  }, []);

  const onSubmit = async (data) => {
    const { username, phoneNo, otp } = location.state;
    const sendData = {
      username,
      phoneNo,
      otpToken: otp,
      password: data.password,
    };
    try {
      const res = await resetPassword(sendData);
      if (res.status === 200) {
        dispatch(
          notify({
            title: 'Success',
            description: res.data.msg,
            status: 'success',
            duration: 5000,
          }),
        );
        history.replace(LOG_IN_URL);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const formFields = [
    {
      id: 'password',
      name: 'password',
      isRequired: true,
      label: 'New Password',
      type: showPass ? 'text' : 'password',
      placeholder: 'Enter your new password',
      rightElement: showPass ? (
        <ViewIcon onClick={() => setShowPass(false)} cursor="pointer" mt={1.5} />
      ) : (
        <ViewOffIcon onClick={() => setShowPass(true)} cursor="pointer" mt={1.5} />
      ),
    },
    {
      id: 'rePassword',
      name: 'rePassword',
      isRequired: true,
      label: 'Confirm Password',
      placeholder: 'Confirm new password',
      type: showRePass ? 'text' : 'password',
      rightElement: showRePass ? (
        <ViewIcon onClick={() => setShowRePass(false)} cursor="pointer" mt={1.5} />
      ) : (
        <ViewOffIcon onClick={() => setShowRePass(true)} cursor="pointer" mt={1.5} />
      ),
    },
  ];

  const LoginValidationSchema = yup.object().shape({
    password: yup
      .string()
      .matches(PASSWORD_REGEX(location?.state?.minPassLength), {
        message: `Password must be ${location?.state?.minPassLength} to 64 characters long and contain at least one uppercase letter, one lowercase letter, one number and one special character (@$!%*?&)`,
      })
      .required(),
    rePassword: yup
      .string()
      .oneOf([yup.ref('password'), null], 'Passwords must match')
      .required(),
  });

  return (
    <AuthWrapper>
      <AuthForm
        columns={1}
        onSubmit={onSubmit}
        formFields={formFields}
        formSubmitName="CONFIRM"
        formName="Reset Password"
        validationSchema={LoginValidationSchema}
        extraField={
          <Link to={LOG_IN_URL} style={{ maxWidth: 'fit-content' }}>
            <Text
              fontSize="sm"
              opacity={0.45}
              transition="0.5s"
              color="primary.700"
              _hover={{ opacity: 1 }}>
              Back to Login?
            </Text>
          </Link>
        }
      />
    </AuthWrapper>
  );
};

export default ResetPassword;
